import React from 'react';
import classnames from 'classnames';
import {CheckIcon} from 'icons';
import './checks.scss';

const CheckLabel = ({children}) => <div className="check-label">{children}</div>;
const CheckText = ({children}) => <div className="check-text">{children}</div>;
const CheckColumn = ({label, text, green}) => (
  <div className={classnames('check-column', {green})}>
    <CheckLabel>{label}</CheckLabel>
    <CheckText>{text}</CheckText>
  </div>
);

const Check = props => (
  <li className={classnames('check-item', props.className)}>
    <div className="check-description">
      <CheckIcon />
      <CheckColumn label={props.label} text={props.text} />
    </div>
    <div className="check-content">{props.children}</div>
  </li>
);

export const Teams = ({event: {home, away}, strategy: {teams}}) => (
  <Check
    label="Teams in strategy"
    className="teams"
    text={teams.map((team, idx) => {
      const last = idx === teams.length - 1;
      return [home.id, away.id].includes(team.id) ? (
        <b>
          {team.name}
          {!last && ', '}{' '}
        </b>
      ) : (
        <span>
          {team.name}
          {!last && ', '}{' '}
        </span>
      );
    })}
  />
);

export const Leagues = ({event, strategy: {leagues}}) => (
  <Check
    label="Leagues in strategy"
    className="leagues"
    text={leagues.map((league, idx) => {
      const last = idx === leagues.length - 1;
      return league.id === event.league.id ? (
        <b key={league.id}>
          {league.name}
          {!last && ', '}{' '}
        </b>
      ) : (
        <span key={league.id}>
          {league.name}
          {!last && ', '}{' '}
        </span>
      );
    })}
  />
);

export const odds = ({
  checks: {
    odds: {actual, expected},
  },
}) => (
  <Check label="Odds" text={`${expected.min} — ${expected.max < 5 ? expected.max : 'Over 5'}`}>
    <CheckColumn green label="Actual" text={actual.toFixed(2)} />
  </Check>
);

export const opponentPPG = ({
  checks: {
    opponentPPG: {actual, expected},
  },
}) => (
  <Check label="Opponent's PPG" text={`${expected.min} — ${expected.max}`}>
    <CheckColumn green label="Actual" text={actual.toFixed(2)} />
  </Check>
);

export const sides = ({
  checks: {
    sides: {actual, expected}, // eslint-disable-line
  },
}) => <Check label="Sides" text={[expected.home && 'Home', expected.away && 'Away'].filter(v => v).join(', ')} />;

export const totalGoalsAvg = ({
  checks: {
    totalGoalsAvg: {actual, expected},
  },
}) => {
  const labels = {
    one_of_team: 'One of teams has',
    both_teams: 'Both teams have',
    home_team: 'Home team has',
    away_team: 'Away team has',
  };

  return (
    <Check
      label="Total Goals Avg"
      text={`${labels[expected.applyTo]} total goals avg in range ${expected.min} — ${expected.max}`}
    >
      <CheckColumn green label="Actual Home/Away" text={`${actual.homeTGA.toFixed(2)}/${actual.awayTGA.toFixed(2)}`} />
    </Check>
  );
};

export const streak = ({event, strategyType, pick, checks: {streak}}) => {  // eslint-disable-line
  const {actual, expected, teamId} = streak;
  const team = [event.home, event.away].find(({id}) => id === teamId);
  const labels = {
    time_to_win: ['no win'],
    time_to_draw: ['no draw'],
    time_to_lose: ['no lose'],
    time_to_btts: ['btts', 'no btts'],
    avg: ['Avg', 'average'],
    max: ['Max', 'maximum'],
  };

  const text = `
    ${team.name} has ${pick === 'btts:no' ? '' : 'no'} ${labels[strategyType][0]} streak over
    ${expected === 'avg' || expected === 'max' ? ` its ${labels[expected][1]}` : expected}
    ${streak.margin > 0 ? `(+${streak.margin})` : ''}
    ${streak.margin < 0 ? `(${streak.margin})` : ''}
  `;

  return (
    <Check label="Streak factor" text={text}>
      {typeof expected !== 'number' && (
        <CheckColumn label={labels[expected][0]} text={streak[expected].toFixed(expected === 'max' ? 0 : 2)} />
      )}
      <CheckColumn green label="Actual" text={actual} />
    </Check>
  );
};
